import axios from 'axios'

import { API_URL } from '../const'
import { transformRequest } from './util'

export const service = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  transformRequest: [transformRequest],
})
